<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import {
  type DailyLessonCardKollegeExpenseRecordDailyLessonInputFragment,
  type DailyLessonCardKollegeUserFragment,
} from './DailyLessonCard.generated'
import DailyLessonStatus from './DailyLessonStatus/DailyLessonStatus.vue'
import { useModal } from '@/hooks/useModal'
import DailyLessonInstructorCommentModal from './DailyLessonInstructorCommentModal/DailyLessonInstructorCommentModal.vue'
import { ref } from 'vue'

const props = defineProps<{
  dailyLessonInput: DailyLessonCardKollegeExpenseRecordDailyLessonInputFragment
  user: DailyLessonCardKollegeUserFragment
}>()

const dailyLessonInputEdited = ref(props.dailyLessonInput)

const { ControlledModal, openModal, closeModal } = useModal()

const closeInstructorCommentEditModal = (
  dailyLessonInput: { instructorComment: string | null } | null
) => {
  if (dailyLessonInput) {
    dailyLessonInputEdited.value = {
      ...dailyLessonInputEdited.value,
      instructorComment: dailyLessonInput.instructorComment,
    }
  }
  closeModal()
}
</script>
<template>
  <div :class="$style.card">
    <DailyLessonStatus :daily-lesson-input="dailyLessonInput" />
    <h2 :class="$style.title">{{ props.dailyLessonInput.title }}</h2>
    <FlatButton variant="primary" :class="$style.button" @click="openModal">
      <template v-if="dailyLessonInputEdited.instructorComment">
        編集する
      </template>
      <template v-else> 記入する </template>
    </FlatButton>
    <component :is="ControlledModal" @close="closeInstructorCommentEditModal">
      <DailyLessonInstructorCommentModal
        :user="props.user"
        :nth-day="props.dailyLessonInput.nth_day"
        @close="closeInstructorCommentEditModal"
      />
    </component>
  </div>
</template>

<style lang="scss" module>
.card {
  display: flex;
  padding: 24px;
  border-radius: 12px;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 4px 12px 0 #0000001a;
}

.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.8;
}

.button {
  align-self: flex-end;
}
</style>
